class FileData {
    constructor() {
        this.name = "";
        this.content = null;
        this.path = "";
    }
}
export default FileData